import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
const BatchItem = props => {
  return (
    <NavLink
      activeClassName="active"
      to={`/Results/${props.item.batchNo}`}
      className="btn btn-primary btn-sm m-5 jsButtonBatch"
    >
      {props.item.batchName}{" "}
    </NavLink>
  );
};
export default BatchItem;



// WEBPACK FOOTER //
// ./src/pages/results/BatchItem.js